module.exports = __webpack_public_path__ + "assets/img/d40e6d028555be065796555a4139175c.svg";